






































































































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";
import Multiselect from "vue-multiselect";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import swal from "sweetalert";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  BillingType,
  EventPriceForm,
  IFacility,
  IInventoryProduct,
  IVat
} from "@/interface";
import { AxiosResponse } from "axios";
import { quillEditor } from "vue-quill-editor";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    quillEditor,
    Multiselect,
    Error404
  }
})
export default class InventoryProduct extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "short_name",
    "description",
    "vat_id",
    "amount",
    "form",
    "billing_type",
    "accounting_code",
    "max_available_units"
  ];
  private noDataExist = false;
  private availableVats: Array<IVat> | null = null;
  private locationValue: Array<IFacility> = [];
  private locationOptions: Array<IFacility> = [];
  private selectedInventoryProduct: IInventoryProduct = {
    name: null,
    short_name: null,
    description: null,
    bookable_online: false,
    min_booking_mins: 0,
    max_booking_mins: 0,
    lead_mins: 0,
    follow_up_mins: 0,
    vat_id: 1,
    amount: null,
    form: EventPriceForm.GROSS,
    billing_type: BillingType.FIXED,
    max_available_units: 0,
    accounting_code: ""
  };
  private selectedInventoryProductId: string | null = null;
  private editorOptions: any = {
    modules: {
      toolbar: [
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }]
      ]
    },
    placeholder: ""
  };

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedInventoryProductId = vm.$route.params.inventory_product_id;

      // Get Inventory
      if (
        typeof vm.selectedInventoryProductId !== "undefined" &&
        vm.selectedInventoryProductId !== null
      ) {
        if (vm.$route.query.inventory_product_created === "true") {
          swal("Success!", "The inventory was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getInventoryProduct(() => {
          //
        });
      }

      // Get Available vats
      vm.getVats(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    // Get Inventory
    if (
      typeof this.selectedInventoryProductId !== "undefined" &&
      this.selectedInventoryProductId !== null
    ) {
      this.getInventoryProduct(() => {
        //
      });
    }

    // Get Available vats
    this.getVats(() => {
      //
    });
    next();
  }

  private addLocation(location: IFacility): void {
    this.locationValue.push(location);
  }

  private createOrUpdateInventoryProduct(): void {
    if (this.selectedInventoryProductId == null) {
      this.createInventoryProduct();
    } else {
      this.updateInventoryProduct();
    }
  }

  private createInventoryProduct(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("inventory-products");
    if (this.locationValue && this.locationValue.length) {
      this.selectedInventoryProduct.facility_ids = this.locationValue.map(
        (facility: IFacility) => facility.id
      );
    }

    Api()
      .post(endpoint, this.selectedInventoryProduct)
      .then((response: AxiosResponse) => {
        this.selectedInventoryProductId = response.data.data.id;
        this.$router.push({
          name: "InventoryProductDetails",
          params: {
            inventory_product_id: `${this.selectedInventoryProductId}`
          },
          query: { inventory_product_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getInventoryProduct(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "inventory-products/" + this.selectedInventoryProductId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedInventoryProduct = response.data.data;
        if (response.data.data.price) {
          if (response.data.data.price.vat) {
            this.selectedInventoryProduct.vat_id =
              response.data.data.price.vat.id;
          }
          this.selectedInventoryProduct.form = response.data.data.price.form;
          this.selectedInventoryProduct.amount =
            response.data.data.price.form === "net"
              ? response.data.data.price.amount_net
              : response.data.data.price.amount_gross;
          this.selectedInventoryProduct.billing_type =
            response.data.data.price.billing_type;
        }
        if (
          response.data.data.facilities &&
          response.data.data.facilities.length
        ) {
          this.selectedInventoryProduct.facility_ids = response.data.data.facilities.map(
            (facility: IFacility) => facility.id
          );
          this.locationValue = response.data.data.facilities.map(
            (facility: IFacility) => ({
              id: facility.id,
              name: facility.name
            })
          );
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateInventoryProduct(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "inventory-products/" + this.selectedInventoryProductId
    );
    if (this.locationValue && this.locationValue.length) {
      this.selectedInventoryProduct.facility_ids = this.locationValue.map(
        facility => facility.id
      );
    }

    Api()
      .put(endpoint, this.selectedInventoryProduct)
      .then(() => {
        this.getInventoryProduct();
        swal({
          title: "Success!",
          text: "The inventory product updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteInventoryProduct(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text:
        "The inventory product will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "inventory-products/" + this.selectedInventoryProductId
        );

        Api()
          .delete(endpoint)
          .then((response: AxiosResponse) => {
            console.log(response.status);
            this.$router.push({
              name: "InventoryProducts",
              query: { inventory_product_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete inventory products.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getVats(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: any = this.$partnerEndpoint("vats");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.availableVats = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get editor(): any {
    return (this.$refs.instructorDescriptionEditor as any).quill;
  }
}
